const tabs = (cms) => {
  return [
    {
      id: "all",
      content: cms("label.tab.all"),
      accessibilityLabel: "All",
      panelID: "all",
    },
    {
      id: "firstLogin",
      content: cms("label.tab.firstLogin"),
      panelID: "first-login",
    },
    {
      id: "appInstall",
      content: cms("label.tab.appInstall"),
      panelID: "app-install",
    },
    {
      id: "appUninstall",
      content: cms("label.tab.appUninstall"),
      panelID: "app-uninstall",
    },
    {
      id: "vendorSignUp",
      content: cms("label.tab.supplierSignUp"),
      panelID: "vendor-sign-up",
    },
    {
      id: "sellerSignUp",
      content: cms("label.tab.sellerSignUp"),
      panelID: "seller-sign-up",
    },
  ];
};

export default tabs;
